import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { Limit } from "../LimitRecord";

import { orgLimitsQueryKey } from "./useOrgLimits";

/**
 * Create or replace one limit override (backend-enforced system-user-only).
 *
 * The invalidation key comes from ``limit.principal.id`` — for org-scoped
 * rows that is the org id, so callers can pass a row from ``useOrgLimits``
 * back verbatim (with a new quantity) and the right org's cache refreshes
 * without threading an extra orgId parameter through the hook.
 */
export function useUpdateOrgLimit() {
  const { limitSummary } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<void, Error, Limit>({
    mutationFn: (limit) => limitSummary.updateLimit(limit),
    onSuccess: (_data, limit) => {
      void queryClient.invalidateQueries({
        queryKey: orgLimitsQueryKey(limit.principal.id),
      });
    },
  });
}
